import { render, staticRenderFns } from "./ClientProductSalesHistoryCard.vue?vue&type=template&id=4819f334&scoped=true"
import script from "./ClientProductSalesHistoryCard.vue?vue&type=script&lang=js"
export * from "./ClientProductSalesHistoryCard.vue?vue&type=script&lang=js"
import style0 from "./ClientProductSalesHistoryCard.vue?vue&type=style&index=0&id=4819f334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4819f334",
  null
  
)

export default component.exports